// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.autoplay-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.autoplay-modal-content {
  background-color: #faf8f5;
  color: black;
  padding: 32px 24px;
  border-radius: 16px;
  text-align: center;
  width: 450px;
  max-height: 90vh;
  overflow-y: auto;
}

.autoplay-modal-content h2 {
  margin-top: 0;
  color: black;
  font-size: 24px;
  text-align: center;
  font-family: 'Crimson', serif;
}

.autoplay-modal-content p {
    line-height: 1.3;
    font-size: clamp(12px, 1.4vw, 18px) !important;
    font-style: normal !important;
    margin: 0;
    margin-bottom: 1em;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Story/AutoplayModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,8CAA8C;IAC9C,6BAA6B;IAC7B,SAAS;IACT,kBAAkB;AACtB","sourcesContent":[".autoplay-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.autoplay-modal-content {\n  background-color: #faf8f5;\n  color: black;\n  padding: 32px 24px;\n  border-radius: 16px;\n  text-align: center;\n  width: 450px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.autoplay-modal-content h2 {\n  margin-top: 0;\n  color: black;\n  font-size: 24px;\n  text-align: center;\n  font-family: 'Crimson', serif;\n}\n\n.autoplay-modal-content p {\n    line-height: 1.3;\n    font-size: clamp(12px, 1.4vw, 18px) !important;\n    font-style: normal !important;\n    margin: 0;\n    margin-bottom: 1em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
